import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import { useKey } from '../../../customhooks/useKey';
import MuiFaIcon from '../../../atomicDesign/atoms/MuiFaIcon';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './PdfViewer.scss';

// Set the worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function PdfViewer() {
  const [searchParams] = useSearchParams();
  const pdfUrl = searchParams.get('path') || '';
  const [numPages, setNumPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useKey('ArrowLeft', () => {
    if (currentPage > 2) {
      goToPreviousPages();
    }
  });

  useKey('ArrowRight', () => {
    if (currentPage + 1 < numPages) {
      goToNextPages();
    }
  });

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const goToPreviousPages = () => {
    if (currentPage > 2) {
      setCurrentPage(currentPage - 2);
    } else {
      setCurrentPage(1);
    }
  };

  const goToNextPages = () => {
    if (currentPage + 1 < numPages) {
      setCurrentPage(currentPage + 2);
    }
  };

  const goToFirstPage = () => {
    setCurrentPage(1);
  };

  if (!pdfUrl) {
    return (
      <p>No PDF file specified. Please provide a valid path in the URL.</p>
    );
  }

  return (
    <div className="pdf-viewer">
      <a href={pdfUrl} download="document.pdf" className="pdf-button download">
        Download PDF
      </a>
      <div className="pdf-container">
        <Document
          file={pdfUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<p>Loading PDF...</p>}
        >
          <div className="pdf-pages">
            {/* Left Page */}
            <Page pageNumber={currentPage} width={500} />
            {/* Right Page */}
            {currentPage + 1 <= numPages && (
              <Page pageNumber={currentPage + 1} width={500} />
            )}
          </div>
        </Document>
      </div>
      {numPages && (
        <p>
          Pages {currentPage}{' '}
          {currentPage + 1 <= numPages && `and ${currentPage + 1}`} of{' '}
          {numPages}
        </p>
      )}
      <div className="pdf-controls">
        {currentPage > 1 && (
          <button onClick={goToFirstPage} className="pdf-button first">
            <MuiFaIcon name="fa-sharp-duotone fa-regular fa-house" />
          </button>
        )}
        <button
          onClick={goToPreviousPages}
          disabled={currentPage <= 1}
          className="pdf-button"
        >
          <span style={{ fontSize: '16px' }}>&#9664;</span> Previous
        </button>
        <button
          onClick={goToNextPages}
          disabled={currentPage + 1 >= numPages}
          className="pdf-button"
        >
          Next <span style={{ fontSize: '16px' }}>&#9654;</span>
        </button>
      </div>
    </div>
  );
}
